export const addMinutesToTimeInterval = (timeInterval, amount) => {
    if (timeInterval === "") {
        return "";
    }
    const [from, to] = timeInterval.split(" - ");
    const fromWithAdded = addMinutes(from, amount);
    let toWithAdded = to ? addMinutes(to, amount) : to;
    return `${toWithAdded} - ${fromWithAdded}`;
};
export const addMinutes = (time, amount) => {
    const [hours, minutes] = time.split(":");
    const hoursInt = parseInt(hours);
    const minutesInt = parseInt(minutes);
    let minutesAfterAdd = minutesInt + amount;
    let hoursAfterAdd = hoursInt + Math.floor(minutesAfterAdd / 60);
    while (minutesAfterAdd >= 60) {
        minutesAfterAdd -= 60;
    }
    while (minutesAfterAdd < 0) {
        minutesAfterAdd += 60;
    }
    if (hoursAfterAdd >= 24) {
        hoursAfterAdd = 23;
        minutesAfterAdd = 59;
    }
    if (hoursAfterAdd < 0) {
        hoursAfterAdd = 0;
        minutesAfterAdd = 0;
    }
    let hoursAfterAddStr = hoursAfterAdd.toString();
    let minutesAfterAddStr = minutesAfterAdd.toString();
    if (hoursAfterAdd < 10) {
        hoursAfterAddStr = `0${hoursAfterAddStr}`;
    }
    if (minutesAfterAdd < 10) {
        minutesAfterAddStr = `0${minutesAfterAddStr}`;
    }
    if (minutesAfterAddStr.length !== 2) {
        throw new Error(`Error ${minutesAfterAddStr}`);
    }
    if (hoursAfterAddStr.length !== 2) {
        throw new Error(`Error ${hoursAfterAddStr}`);
    }
    return `${hoursAfterAddStr}:${minutesAfterAddStr}`;
};
export const subtractMinutes = (time, amount) => {
    return addMinutes(time, -amount);
};
export const diffMinutes = (time1, time2) => {
    const [hours1, minutes1] = time1.split(":");
    const [hours2, minutes2] = time2.split(":");
    const hoursDiff = parseInt(hours2) - parseInt(hours1);
    const minutesDiff = parseInt(minutes2) - parseInt(minutes1);
    return hoursDiff * 60 + minutesDiff;
};
//# sourceMappingURL=time-utils.js.map